import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import Products from 'merchandise-lib/constants/Product';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { BaseCardBadge } from '../../../v2/components/merch-card/BaseCardBadge';
import { useBadges } from '../../../v2/hooks/badges/useBadges';
import { getI18nKeyOverrideForProductCard } from '../I18nUtils';
import { ProductCard } from '../cards/product-card/ProductCard';
import { ProductCards } from '../cards/product-card/ProductCards';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductCardContainer = ({
  screen,
  productsToShow,
  trackingSource
}) => {
  const isAppReady = useGlobalLoading();
  const {
    badges,
    hasBadgeOnFirstColumn,
    hasBadgeOnLastColumn
  } = useBadges({
    productApiNames: productsToShow
  });
  if (!isAppReady) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      minHeight: 200,
      size: "md",
      grow: true
    });
  }
  return /*#__PURE__*/_jsx(ProductCards, {
    columns: productsToShow.length,
    hasBadgeOnFirstColumn: hasBadgeOnFirstColumn,
    hasBadgeOnLastColumn: hasBadgeOnLastColumn,
    children: productsToShow.map((apiName, index) => {
      var _badges$apiName;
      const i18nKeys = getI18nKeyOverrideForProductCard(apiName);
      return /*#__PURE__*/_jsx(ProductCard, {
        apiName: apiName,
        columnStart: index + 1,
        screen: screen,
        trackingSource: trackingSource,
        Title: i18nKeys === null || i18nKeys === void 0 ? void 0 : i18nKeys.Title,
        Description: i18nKeys === null || i18nKeys === void 0 ? void 0 : i18nKeys.Description,
        Badge: /*#__PURE__*/_jsx(BaseCardBadge, {
          apiName: apiName,
          badgeName: badges === null || badges === void 0 || (_badges$apiName = badges[apiName]) === null || _badges$apiName === void 0 ? void 0 : _badges$apiName.badgeName
        }),
        skipInterstitialPage: [Products.CORE_SEATS_PROFESSIONAL, Products.CORE_SEATS_ENTERPRISE].includes(apiName)
      }, apiName);
    })
  });
};